// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    BE_URL: 'https://api-dev.chohoatuoi.com.vn',
    RELOAD_ORDER_TIME: 600000, // 60s
    VNP_SECUREHASH: 'SLPIXUZVSVANJDGIHBDOICRMEXPNBJJP',
    ABOUT_DATE_NUMBER: 1,
    IMAGE_UPLOAD_NUMBER: 4,
    IMAGE_UPLOAD_CAMERA_NUMBER: 2,
    firebase: {
        apiKey: 'AIzaSyApRmdNI2_lGlHNRLnsjsSzHWFR8xNJas0',
        authDomain: 'chohoatuoidev-a303c.firebaseapp.com',
        projectId: 'chohoatuoidev-a303c',
        storageBucket: 'chohoatuoidev-a303c.firebasestorage.app',
        messagingSenderId: '391518114982',
        appId: '1:391518114982:web:12d66abed3dd09e6909067',
        measurementId: 'G-L224Z3CF86',
    },
    BAO_GIA_URL: (token: string): string =>
        `https://dev-guest.chohoatuoi.com.vn/public/quotation?token=${token}`,
    ALLOW_PAST_ORDER_DATE: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
